import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Owner } from '@/reports/PersonBasedReport';
import { Stack, styled, Text, Link, Button } from '@/theme/index';
import { nameize } from '@/utils/nameize';

const StyledStack = styled(Stack)(({ theme }) => ({
  Height: '135px',
  borderRadius: '10px',
  border: '1px solid #E0E0E0',
  backgroundColor: '#FFFFFF',
  padding: '10px',
  display: 'block',
  justifyContent: 'space-around',
  alignItems: 'center',
  flexDirection: 'row',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2.5),
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    Padding: '5px',
    height: `75px`,
  },
}));

const StyledNameStack = styled(Stack)(({ theme }) => ({
  display: 'inline-block',
  position: 'relative',
  left: '10px',
  bottom: '15px',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    bottom: '0',
    marginRight: '18px',
  },
}));

const StyledImg = styled('img')(({ theme }) => ({
  marginBottom: '7px',
  display: 'inline-block',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    margin: '0 auto',
  },
}));

const StyledClaimedImg = styled('img')(() => ({
  height: '15px',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  fontSize: '12px',
  marginBottom: '8px',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));

interface FamilyTreeFeaturesProps {
  report: Owner;
  permalink: string;
}

export const FamilyTreeBadge = ({
  report,
  permalink,
}: FamilyTreeFeaturesProps) => {
  const { images } = useAppConstantsContext();
  const { familyTreeImages } = images;

  const { navigate } = useAppConfigContext().routingUtils;

  return (
    <StyledStack>
      <StyledImg
        src={familyTreeImages!.imgFamilyTreePlaceholder}
        alt="placeholder"
      />
      <StyledNameStack>
        <Link
          onClick={() => navigate(`/report/person?permalink=${permalink}`)}
          target="_blank"
          rel="noopener"
          underline="always"
          sx={{
            fontSize: '16px',
            marginBottom: 0.5,
          }}
        >
          {nameize(report.identity?.names![0].full || '')}
        </Link>
        <Text
          sx={{
            variant: 'body2',
          }}
        >
          {report.location?.parsed?.city}, {report.location?.parsed?.state}
        </Text>
      </StyledNameStack>
      <Stack>
        <StyledButton
          onClick={() => navigate(`/report/person?permalink=${permalink}`)}
          variant="contained"
          color="success"
        >
          View Report
        </StyledButton>
        <Stack>
          <StyledClaimedImg
            src={familyTreeImages!.imgFamilyTreeCheckIcon}
            alt="check_img"
          />
        </Stack>
      </Stack>
    </StyledStack>
  );
};
